import React, { Component } from "react";
import s from "./styles.scss";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import ReasignacionVendedorTable from "./ReasignacionVendedor.table";
import { ReasignacionVendedorStore } from "../../../containers/comisionesAnualidad/reasignacion/ReasignacionVendedor.store";
import { ReasignacionVendedorDispatcher } from "../../../containers/comisionesAnualidad/reasignacion/ReasignacionVendedor.dispatcher";
import {
  errorNotification,
  successNotification
} from "../../../../utils/notifications";
import { Styled } from "../../../../toolkit/decorators/Artifact";

interface Props
  extends ReasignacionVendedorStore,
    ReasignacionVendedorDispatcher {}

interface State {
  selectedFile: File | null;
  mostrarBotonConfirmar: boolean;
}

@Styled(s)
export default class ReasignacionVendedorComponent extends Component<
  Props,
  State
> {
  state = {
    selectedFile: null,
    mostrarBotonConfirmar: false
  };

  onFileChange = evt => {
    if (evt.target.files && evt.target.files.length > 0) {
      this.setState({
        selectedFile: evt.target.files[0],
        mostrarBotonConfirmar: false
      });
    }
  };

  onValidarReasignacion = async () => {
    const { selectedFile } = this.state;

    if (!selectedFile) {
      errorNotification("Debe seleccionar un archivo Excel");
      return;
    }

    const formData = new FormData();
    formData.append("archivo", selectedFile);

    const preview = await this.props.postCambiarVendedorMasivo(formData, false);

    if (preview.fulfilled) {
      const resumen = preview.cambiarVendedorMasivoResult;

      if (resumen && resumen.length > 0) {
        const hasErrors = resumen.some(r => r.resultado === "ERROR");

        if (!hasErrors) {
          successNotification(
            "Validación completada. Revise los resultados y confirme la reasignación."
          );
          this.setState({ mostrarBotonConfirmar: true });
        } else {
          errorNotification(
            "Algunos registros contienen errores. Revise la tabla y corrija el archivo."
          );
          this.setState({ mostrarBotonConfirmar: false });
        }
      } else {
        errorNotification("No se encontraron registros para procesar");
        this.setState({ mostrarBotonConfirmar: false });
      }
    } else {
      errorNotification(
        preview.postingCambiarVendedorMasivoError ||
          "Error al validar la reasignación"
      );
      this.setState({ mostrarBotonConfirmar: false });
    }
  };

  onConfirmarReasignacion = async () => {
    const { selectedFile } = this.state;

    const formData = new FormData();
    formData.append("archivo", selectedFile);

    const preview = await this.props.postCambiarVendedorMasivo(formData, true);

    if (preview.fulfilled) {
      successNotification(
        "Reasignación de vendedores completada correctamente"
      );
      this.setState({ mostrarBotonConfirmar: false, selectedFile: null });
    } else {
      errorNotification(
        preview.postingCambiarVendedorMasivoError ||
          "Error al confirmar la reasignación"
      );
    }
  };

  isWaiting = () => {
    return this.props.postingCambiarVendedorMasivo;
  };

  spinnerOnWait = (label: string) => {
    return this.isWaiting() ? (
      <FontAwesomeIcon icon={faSpinner} pulse />
    ) : (
      label
    );
  };

  render() {
    const { cambiarVendedorMasivoResult: resumen } = this.props;
    const { selectedFile, mostrarBotonConfirmar } = this.state;
    const layoutHref =
      "https://docs.google.com/spreadsheets/d/1wugaBl5ro9wmUGi6pprp8OQ3ik32eAFWtObTNLEzDk8";

    return (
      <>
        <div className="container">
          <div className="row mt-3">
            <div className="col-12">
              <div className="alert alert-info">
                <p className="mt-2 mb-0">
                  Puede descargar el layout de ejemplo{" "}
                  <a href={layoutHref} target="_blank">
                    aquí
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md-3">
              <Button
                type="button"
                className={`${s.primaryButton} ${s.fileButton}`}
                size="sm"
                block
                disabled={this.isWaiting()}
                onClick={e => {
                  if (this.isWaiting()) {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                }}
              >
                {this.spinnerOnWait("Seleccionar archivo")}
                <input
                  className={s.inputFile}
                  type="file"
                  accept=".xlsx,.xls"
                  title=""
                  disabled={this.isWaiting()}
                  onChange={this.onFileChange}
                />
              </Button>
              {selectedFile && (
                <small className="text-muted d-block mt-1">
                  {selectedFile.name}
                </small>
              )}
            </div>

            <div className="col-md-3">
              <Button
                className={`${s.primaryButton}`}
                type="button"
                size="sm"
                block
                onClick={this.onValidarReasignacion}
                disabled={!selectedFile || this.isWaiting()}
              >
                {this.spinnerOnWait("Validar reasignación")}
              </Button>
            </div>

            {mostrarBotonConfirmar && (
              <div className="col-md-3">
                <Button
                  color="success"
                  type="button"
                  size="sm"
                  block
                  onClick={this.onConfirmarReasignacion}
                  disabled={this.isWaiting()}
                >
                  {this.spinnerOnWait("Confirmar reasignación")}
                </Button>
              </div>
            )}
          </div>

          {resumen && resumen.length > 0 && (
            <div className="mt-4">
              <ReasignacionVendedorTable resumen={resumen} />
            </div>
          )}
        </div>
      </>
    );
  }
}
